<template>
    <v-fade-transition hide-on-leave>
        <node-area v-show="shows" v-model="form" v-bind="{ mode, size }" @input="emit">
            <component
                :is="`node-${value.type.toLowerCase()}`"
                v-model="form"
                v-bind="{
                    class: 'item-node__content',
                    mode,
                }"
                v-on="{
                    pull,
                    input: emit,
                }"
            />
        </node-area>
    </v-fade-transition>
</template>

<script>
import { mapState } from "vuex";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentField } from "@/assets/variables";

import NodeArea from "./node/node-area.vue";
import NodeCbox from "./node/node-cbox.vue";
import NodeDate from "./node/node-date.vue";
import NodeSign from "./node/node-sign.vue";
import NodeText from "./node/node-text.vue";

export default {
    components: {
        NodeArea,
        NodeCbox,
        NodeDate,
        NodeSign,
        NodeText,
    },
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        size: { type: Object, default: () => ({ width: null, height: null }) },
    },
    data: () => ({
        form: initEmploymentField(),

        EMPLOYMENT_FIELD_TYPES,
    }),
    computed: {
        ...mapState("employment/form/page", ["shows"]),
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        pull() {
            this.$emit("pull", this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.item-node__content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    text-align: center;
}
</style>
